import { render, staticRenderFns } from "./EditPrice.vue?vue&type=template&id=827f7488"
import script from "./EditPrice.vue?vue&type=script&lang=js"
export * from "./EditPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports